import { join } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { fromIsoDate, getCodelistPropById } from 'utils';

export const getStringOrOneOf = (first, second, third, comma) => {
	if (first && second && third && !comma) return `${first} ${second} ${third}`;

	if (first && second && third && comma) return `${first}, ${second} ${third}`;

	if (first && second) return `${first} ${second}`;

	if (first && third) return `${first} ${third}`;

	if (third) return third;

	if (first) return first;

	return second;
};

export const generateAddressFromValue = (street, zipCode, city) => {
	const firstPart = street;
	const secondPart = [zipCode, city];

	const secondPartRealValuesOnly = secondPart.filter((value) => !isNilOrEmpty(value));
	const secondPartToString = join(' ', secondPartRealValuesOnly);
	const finalValuesToString = [firstPart, secondPartToString].filter((value) => !isNilOrEmpty(value));
	return join(', ', finalValuesToString);
};

export const additionalInformationFieldsTask17Factory = (metadataCommon, frequencyPaymentsCodelist) => {
	const frequencyPaymentByValue = metadataCommon.paymentFrequency
		? getCodelistPropById(metadataCommon.paymentFrequency, frequencyPaymentsCodelist)
		: '';

	const data = {
		productSystem: 'KDP',
		firstObtainer: metadataCommon.firstObtainer,
		ceding: metadataCommon.ceding,
		secondObtainer: metadataCommon.secondObtainer,
		frequencyPaymentByValue,
		payedBy: fromIsoDate(metadataCommon.payedBy),
		bankCode: metadataCommon.bankCode,
		rateType: metadataCommon.rateType,
		survivalDateMethod: metadataCommon.survivalDateMethod,
		survivalDateText: fromIsoDate(metadataCommon.survivalDateText),
	};

	const rows = [
		{ label: 'detail:additionalInformationsProductSystem', value: data.productSystem, size: 4 },
		{ label: 'detail:additionalInformationsOwnerA', value: data.firstObtainer, size: 8 },
		{ label: 'detail:additionalInformationsVinkulace', value: data.ceding, size: 4 },
		{ label: 'detail:additionalInformationsOwnerB', value: data.secondObtainer, size: 8 },
		{ label: 'detail:additionalInformationsFrequencyPayment', value: data.frequencyPaymentByValue, size: 4 },
		{ label: 'detail:additionalInformationsBankCode', value: data.bankCode, size: 4 },
		{ label: 'detail:additionalInformationsPaidUntil', value: data.payedBy, size: 4 },
		{ label: 'detail:additionalInformationsTypeOfRate', value: data.rateType, size: 4 },
		{ label: 'detail:additionalInformationsSurvivalDateMethod', value: data.survivalDateMethod, size: 4 },
		{ label: 'detail:additionalInformationsSurvivalDateText', value: data.survivalDateText, size: 4 },
	];

	return rows;
};

export const additionalInformationFieldsTask20Factory = (metadataCommon, taskSourceSystemId, systemsCodelist) => {
	const productSystem = getCodelistPropById(taskSourceSystemId, systemsCodelist, 'nickname');
	return [
		{ label: 'detail:additionalInformationsProductSystem', value: productSystem, size: 4 },
		{ label: 'detail:additionalInformationsOwner', value: metadataCommon.obtainer, size: 8 },
		{ label: 'detail:additionalInformationsRateGrid', value: metadataCommon.rate, size: 4 },
		{ label: 'detail:additionalInformationsNameOperator', value: metadataCommon.kdpOperatorName, size: 4 },
		{ label: 'detail:additionalInformationsOperatorNo', value: metadataCommon.kdpOperatorNo, size: 4 },
		{ label: 'detail:additionalInformationsCodeOfProduct', value: metadataCommon.productId, size: 4 },
		{
			label: 'detail:additionalInformationsPhoneOperator',
			value: metadataCommon.kdpOperatorPhone,
			size: 4,
		},
	];
};

export const isOnTaskDetail = () => {
	const onTaskDetailRegExp = new RegExp(/^\/task\/\d+\/detail$/);
	return onTaskDetailRegExp.test(window.location.pathname);
};
